const StatusGroLpp = Object.freeze({
    SEM_DADOS: 'SEM DADOS',
    EM_ANDAMENTO: 'EM ANDAMENTO',
    CONCLUIDO: 'CONCLUÍDO'
});

export default StatusGroLpp;
